<template>
  <div class="row flex-column gy-1 mt-0">
    <div class="col" v-for="item in items" :key="`${type}-${item.id}`">
      <div class="sidebar__item row gx-1 align-items-center">
        <div v-if="hasValidImage(item)" class="col-auto">
          <figure
            @click="$emit('show-modal', item, type)"
            :class="{ clickable: clickable }"
            class="image"
          >
            <img
              :src="item?.images?.medium || item.imageUrl || item.image"
              :alt="decodedItemNames[item.id]"
            />
          </figure>
        </div>
        <div class="col d-flex flex-column overflow-x-hidden">
          <span
            @click="clickable && $emit('show-modal', item, type)"
            class="name fs-sm"
            :class="{ clickable: clickable }"
            >{{ decodedItemNames[item.id] }}</span
          >
          <SidebarItemActions
            :item="item"
            :count="item.count"
            @increase="$emit('increase', $event)"
            @decrease="$emit('decrease', $event)"
            @remove="$emit('remove', $event)"
          />
        </div>
      </div>
    </div>
    <div v-if="!items || items.length === 0" class="col">
      <div class="empty p-3">
        <i class="icon icon-search text-primary fs-2xl"></i>
        <p class="d-block fs-sm lh-sm my-0 text-black">{{ emptyText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarItemActions from './SidebarItemActions.vue';
import { decodeHtml, hasValidImage } from '../utils/productCountUtils.js';

export default {
  name: 'SidebarListSection',
  components: {
    SidebarItemActions,
  },
  emits: ['increase', 'decrease', 'remove', 'show-modal'],
  props: {
    clickable: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    emptyText: {
      type: String,
      default: 'No items selected',
    },
  },
  computed: {
    decodedItemNames() {
      const names = {};
      this.items.forEach((item) => {
        names[item.id] = decodeHtml(item.name || '');
      });
      return names;
    },
  },
  methods: {
    hasValidImage,
  },
};
</script>
